import { useRef, useEffect } from "react";
import { useScroll, useMotionValueEvent } from "framer-motion";

/**
 * useProgressRef
 * Returns a ref { current: 0..1 } reflecting the scroll progress
 * of the wrapping element from top-in-view to bottom-out-of-view.
 * Use the returned `sectionRef` on a wrapping container (typically
 * a tall section with internal `sticky` content).
 */
export function useProgressRef(offset = ["start start", "end end"]) {
  const sectionRef = useRef(null);
  const progressRef = useRef(0);

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset,
  });

  useMotionValueEvent(scrollYProgress, "change", (v) => {
    progressRef.current = v;
  });

  // initial sync (when section already visible on mount)
  useEffect(() => {
    progressRef.current = scrollYProgress.get();
  }, [scrollYProgress]);

  return { sectionRef, progressRef };
}

export const lerp = (a, b, t) => a + (b - a) * t;
export const clamp = (v, mn = 0, mx = 1) => Math.min(mx, Math.max(mn, v));
export const easeInOut = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
export const segment = (t, a, b) => clamp((t - a) / (b - a));
